import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useTitle } from '../hooks/useTitle';

import BrandMessage from 'src/components/Notification/BrandMessage/BrandMessage';
import KakaoAlimtalkPage from 'src/components/Notification/KakaoAlimtalkSend/KakaoAlimtalkPage';
import KakaoBrandMessageResult from 'src/components/Notification/KakaoBrandMessageResult/KakaoBrandMessageResult';
import NotificationDashboard from 'src/components/Notification/NotificationDashboard/NotificationDashboard';
import NotificationList from 'src/components/Notification/NotificationList/NotificationList';

const NotificationPage: FC<{ title: string }> = ({ title }) => {
  useTitle(`GU 관리자 | ${title}`);
  return (
    <Routes>
      <Route path='/dashboard' element={<NotificationDashboard />} />
      <Route path='/kakao-alimtalk' element={<KakaoAlimtalkPage />} />
      <Route path='/brand-message' element={<BrandMessage />} />
      <Route path='/brand-message-result' element={<KakaoBrandMessageResult />} />
      <Route path='/list' element={<NotificationList />} />
      <Route path='/' element={<Navigate to='/notification/dashboard' replace />} />
    </Routes>
  );
};

export default NotificationPage;
